
import React from 'react';
import { chooseColor } from '../helpers/functions/colors';
import { toCurrency } from '../helpers/functions/math';

const Leftover = ({ expenseSum = 0, incomeSum = 0 }) =>
(
    <div className='Leftover' align="center">
        <h1 className={chooseColor(expenseSum, incomeSum)}>
            {toCurrency(incomeSum - expenseSum)}
        </h1>
    </div>
)


export default Leftover;
